module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 7l-6 6-6-6\" stroke=\"#000\" stroke-width=\"2\" fill=\"none\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ParametersScreen/arrow_down.svg
// module id = 2028
// module chunks = 0